var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"ofertes-list"},_vm._l((_vm.ofertes),function(oferta){return _c('div',{key:oferta.borsa_oferta_id,staticClass:"oferta",class:_vm.addClass(oferta)},[_c('div',{staticClass:"status"},[(oferta.borsa_oferta_actiu === 0)?_c('b-icon-eye-slash-fill',{staticClass:"disabled"}):_vm._e(),(
          oferta.borsa_oferta_tancada_flg && oferta.borsa_oferta_actiu === 1
        )?_c('b-icon-lock-fill',{staticClass:"closed"}):_vm._e()],1),_c('OfertaListItem',{attrs:{"oferta":oferta}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }